module.exports = __webpack_public_path__ + "5c459a75538727c3b15fd5b70354bca6.png";